var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageonly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g201",
    transform: "translate(937.999 1115.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g203",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5994",
    "data-name": "Group 5994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g211",
    transform: "translate(1.719 1.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path213",
    d: "M-464.029,0H-487.4A8.594,8.594,0,0,0-496,8.594V31.969a8.594,8.594,0,0,0,8.594,8.594h23.375a8.594,8.594,0,0,0,8.594-8.594V8.594A8.594,8.594,0,0,0-464.029,0Z",
    transform: "translate(495.999)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g215",
    transform: "translate(26.383 12.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path217",
    d: "M0-31.185a2.148,2.148,0,0,1,2.148-2.148A2.148,2.148,0,0,1,4.3-31.185a2.148,2.148,0,0,1-2.148,2.148A2.148,2.148,0,0,1,0-31.185",
    transform: "translate(0 33.333)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g219",
    transform: "translate(8.68 20.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path221",
    d: "M0-92.307l4.946-5.257a4.3,4.3,0,0,1,5.539-.175l7.977,7.558c1.778,1.406,3.8,1.567,5.6-.41l2.922-3.348",
    transform: "translate(0 98.667)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageonly);
export default __webpack_public_path__ + "static/media/imageonly.1abf173d9d4158f2cc48d8fb15f7c448.svg";
export { ForwardRef as ReactComponent };